export default {
  common: {
    error: "Ocorreu um erro",
    reload: "Recarregar",
    errorNotification: "Fomos notificados e iremos corrigir o mais rapidamente possível. Se o problema persistir, por favor",
    contactUs: "Contacte-nos.",
    language: "Idioma",
    loading: "A carregar...",
    loadingText: "A carregar",
    save: "Guardar",
    savedSuccessfully: "Guardado com Sucesso",
    saving: "A guardar...",
    cancel: "Cancelar",
    edit: "Editar",
    delete: "Eliminar",
    add: "Adicionar",
    search: "Pesquisar",
    filter: "Filtrar",
    clear: "Limpar",
    preview: "Pré-visualizar",
    default: "Predefinido: {{value}}",
    optional: "Opcional",
    required: "Obrigatório",
    noData: "Sem dados",
  },
  // Places navigation
  places: {
    navigation: {
      locations: "Localizações",
      cities: "Cidades", 
      regions: "Regiões",
      countries: "Países",
      showOnMap: "Mostrar no mapa",
      addLocation: "Adicionar localização"
    },
    welcome: {
      title: "Bem-vindo às Localizações So Super.",
      subtitle: "Selecione uma secção na navegação para começar."
    }
  },

  // Cities section
  cities: {
    title: "Cidades",
    resourceSingular: "cidade",
    resourcePlural: "cidades",
    headings: {
      name: "Nome",
      status: "Estado",
      locations: "Localizações", 
      region: "Região",
      country: "País"
    },
    breadcrumbs: {
      cities: "Cidades"
    }
  },

  // Countries section  
  countries: {
    title: "Países",
    resourceSingular: "país", 
    resourcePlural: "países",
    headings: {
      name: "Nome",
      status: "Estado",
      locations: "Localizações",
      cities: "Cidades",
      regions: "Regiões"
    },
    breadcrumbs: {
      countries: "Países"
    }
  },

  // Regions section
  regions: {
    title: "Regiões",
    resourceSingular: "região",
    resourcePlural: "regiões", 
    headings: {
      name: "Nome",
      status: "Estado",
      locations: "Localizações",
      cities: "Cidades",
      country: "País"
    },
    breadcrumbs: {
      regions: "Regiões"
    }
  },

  // Map section
  map: {
    title: "Mapa",
    breadcrumbs: {
      locations: "Localizações"
    }
  },

  // Import section
  import: {
    title: "Importação CSV",
    breadcrumbs: {
      locations: "Localizações"
    },
    new: {
      title: "Importar localizações por CSV",
      description: "Descarregue um modelo CSV de exemplo para ver um exemplo do formato necessário",
      sampleTemplate: "modelo CSV de exemplo",
      uploadAndContinue: "Carregar e continuar",
      abortOnError: "Abortar em caso de erro",
      abortOnErrorHelp: "Se houver um erro, a importação será abortada, será exibido o erro e nenhuma localização será importada.",
      needHelp: "Precisa de ajuda para importar localizações?"
    },
    show: {
      title: "Importação CSV",
      youCanLeavePage: "Pode sair desta página",
      backgroundMessage: "A sua importação ainda correrá em segundo plano",
      importProgress: "Progresso da importação",
      imported: "Importado",
      suffix: "localizações",
      importLog: "Registo de importação",
      cancelImport: "Cancelar importação",
      cancelConfirmation: {
        title: "Cancelar importação",
        message: "Tem a certeza que pretende cancelar este trabalho de importação? Esta ação não pode ser desfeita.",
        note: "Nota: Para trabalhos em curso, o trabalho precisará de ser concluído e será eliminado logo após.",
        yesCancel: "Sim, cancelar importação",
        noContinue: "Não, continuar importação"
      },
      report: "Relatório",
      failedLocations: "Localizações falhadas",
      uploadAnother: "Carregar outro CSV",
      backToLocations: "Voltar às localizações",
      importSucceeded: "Importação realizada com sucesso",
      importFailed: "Importação falhada"
    },
    messages: {
      uploadSuccess: "CSV carregado com sucesso",
      uploadError: "Não foi possível carregar o CSV",
      pending: "A importação ainda não iniciou",
      inProgress: "A importação está em curso",
      completed: "A importação foi concluída",
      invalidHeader: "As seguintes colunas são obrigatórias",
      invalidCsvFile: "Ficheiro CSV inválido",
      aborted: "Importação abortada",
      failed: "Importação falhada",
      cancelled: "Importação cancelada"
    },
    errors: {
      csvTooLarge: "O CSV é demasiado grande",
      languageNotEnabled: "O idioma '{{language}}' não está habilitado para esta loja. Por favor, habilite-o em Configurações > Idiomas primeiro.",
      fieldNotTranslatable: "O campo '{{field}}' não é traduzível. Os campos traduzíveis são: {{fields}}",
      locationError: "Localização com slug: {{slug}} - {{error}}",
      planLimit: "Está no seu limite de plano para localizações"
    }
  },

  // Location form
  location: {
    index: {
      title: "Localizações",
      addLocation: "Adicionar localização",
      import: "Importar",
      noPrioritySet: "Sem prioridade definida",
      published: "Publicado",
      draft: "Rascunho",
      resourceSingular: "localização",
      resourcePlural: "localizações",
      headings: {
        name: "Nome",
        status: "Estado", 
        city: "Cidade",
        region: "Região",
        country: "País",
        priority: "Prioridade"
      }
    },
    form: {
      title: "Adicionar localização",
      editTitle: "Editar localização",
      basicInformation: "Informação básica",
      name: "Nome",
      namePlaceholder: "e.g. Brians Bricks",
      nameHelpDefault: "Predefinido: {{defaultName}}",
      details: "Detalhes",
      description: "Descrição",
      descriptionPlaceholder: "Diga aos clientes o que torna esta localização especial",
      address: "Endereço",
      addressPlaceholder: "123 Main Street, Cidade, País",
      addressLine1: "Linha de endereço 1",
      addressLine2: "Linha de endereço 2",
      postalZipCode: "Código postal / ZIP",
      city: "Cidade",
      stateProvinceRegion: "Estado / Província / Região",
      country: "País",
      phone: "Telefone",
      phonePlaceholder: "+1 (555) 123-4567",
      email: "Email", 
      emailPlaceholder: "loja@exemplo.com",
      website: "Website",
      websitePlaceholder: "https://www.exemplo.com",
      image: "Imagem",
      imagePlaceholder: "Introduza o URL da imagem",
      status: "Estado",
      statusActive: "Ativo",
      statusInactive: "Inativo",
      statusDraft: "Rascunho",
      priority: "Prioridade",
      priorityHelpText: "Localizações com prioridade mais alta aparecem primeiro nos resultados da pesquisa",
      findOnMapButton: "Encontrar no mapa"
    },
    validation: {
      addressNotFound: "Não foi possível encontrar o endereço",
      createSuccess: "Localização criada com sucesso", 
      updateSuccess: "Localização atualizada com sucesso",
      checkFields: "Por favor, verifique os seus campos",
      findOnMap: "Por favor, encontre a sua localização no mapa antes de salvar"
    },
    errors: {
      loading: "Erro ao carregar localização"
    },
    actions: {
      save: "Guardar localização",
      delete: "Eliminar localização",
      preview: "Pré-visualizar"
    },
    customFields: {
      title: "Campos personalizados",
      noCustomFields: "Nenhum campo personalizado configurado",
      configureFields: "Configurar campos",
      emptyState: "Ainda não configurou nenhum campo personalizado. Os campos personalizados permitem-lhe adicionar informações adicionais específicas às suas necessidades de negócio."
    },
    openingHours: {
      title: "Horário de funcionamento",
      checkboxLabel: "Esta localização tem horários de abertura e fecho",
      statusOpen: "Aberto",
      statusOpen24h: "Aberto 24H",
      statusClosed: "Fechado",
      openingTimeLabel: "Horário de abertura",
      closingTimeLabel: "Horário de fecho",
      days: {
        monday: "Segunda-feira",
        tuesday: "Terça-feira", 
        wednesday: "Quarta-feira",
        thursday: "Quinta-feira",
        friday: "Sexta-feira",
        saturday: "Sábado",
        sunday: "Domingo"
      }
    },
    table: {
      sortOptions: {
        recentlyAdded: "Adicionado recentemente",
        recentlyModified: "Modificado recentemente"
      },
      filters: {
        status: "Estado",
        taggedWith: "Marcado com",
        locationStatus: "Estado da localização",
        noTagsToShow: "Nenhum tag para mostrar",
        searchPlaceholder: "Pesquisar"
      },
      bulkActions: {
        setPublished: "Definir como publicado",
        setUnpublished: "Definir como não publicado", 
        setPriority: "Definir prioridade",
        deleteLocations: "Eliminar localizações",
        exportCSV: "Exportar como CSV"
      },
      appliedFilters: {
        statusIs: "Estado é {{status}}",
        taggedWith: "Marcado com {{tag}}",
        nameIncludes: "Nome inclui {{search}}"
      },
      modals: {
        deleteTitle: "Eliminar localizações",
        deleteMessage: "Tem a certeza que pretende eliminar {{count}}?",
        deleteMessageAll: "Tem a certeza que pretende eliminar todas as localizações?",
        prioritiseTitle: "Priorizar {{count}} localizações",
        prioritiseTitleAll: "Priorizar todas as localizações",
        delete: "Eliminar",
        cancel: "Cancelar"
      },
      emptyState: {
        noResultsHeading: "Não foram encontradas nenhuma {{resourcePlural}}",
        noResultsText: "Tente alterar os filtros ou o termo de pesquisa",
        noDataHeading: "Adicione uma localização para popular {{resourcePlural}}",
        addLocation: "Adicionar Localização",
        importFromCSV: "Importar a partir de CSV"
      },
      pagination: {
        label: "Página {{page}} de {{pages}}"
      },
      messages: {
        updatedSuccessfully: "Atualizado com sucesso",
        deletedSuccessfully: "Eliminado com sucesso", 
        exportedSuccessfully: "Exportado com sucesso",
        error: "Ocorreu um erro"
      }
    }
  },

  // SEO Editor
  seo: {
    title: "Conteúdo da página",
    editTemplate: "Editar modelo SEO", 
    pageTitle: "Título",
    pageDescription: "Descrição",
    metaTitle: "Título",
    metaDescription: "Descrição",
    urlHandle: "URL de manipulação",
    searchEnginePreview: "Pré-visualização da lista de resultados do motor de busca",
    editMeta: "Editar Meta",
    previewMeta: "Pré-visualizar Meta",
    loading: "A carregar...",
    editingLocaleHelp: "A editar o conteúdo de {{locale}}."
  },

  // SEO Templates section
  seoTemplates: {
    title: "Modelos SEO",
    breadcrumbs: {
      seoTemplates: "Modelos SEO"
    },
    template: {
      title: "{{templateName}} modelo - {{locale}}",
      discardChanges: "Descartar alterações"
    },
    form: {
      pageContent: "Conteúdo da página",
      searchEnginePreview: "Pré-visualização da lista de resultados do motor de busca",
      title: "Título",
      description: "Descrição",
      pageTitle: "Título da página",
      metaDescription: "Descrição meta",
      editingLocaleHelp: "A editar as traduções de {{locale}}. Os campos vazios irão exibir o conteúdo de {{defaultLocale}}.",
      defaultValue: "Predefinido: {{value}}"
    },
    language: {
      label: "Idioma",
      defaultHelp: "Este é o seu idioma por defeito",
      editingHelp: "A editar as traduções de {{locale}}. Os campos vazios irão exibir o conteúdo de {{defaultLocale}}."
    },
    banner: {
      multipleLanguagesDisabled: "Múltiplos idiomas não habilitados",
      enableInSettings: "Habilitar em Configurações",
      multipleLanguagesInfo: "Para gerir modelos SEO para múltiplos idiomas, habilite a internacionalização nas suas configurações de idioma. Atualmente, apenas são mostrados modelos de {{locale}}."
    },
    badges: {
      errors: "Erros!",
      unsaved: "Não guardado"
    },
    messages: {
      saveSuccess: "Modelos SEO guardados com sucesso",
      saveError: "Não foi possível guardar os modelos",
      error: "Erro..."
    }
  },

  // Area form
  area: {
    form: {
      basicInformation: "Informação básica",
      name: "Nome",
      save: "Guardar",
      saving: "A guardar...",
      cancel: "Cancelar",
      yourLocationsIn: "As suas localizações em {{name}}",
      tableHeadings: {
        name: "Nome",
        status: "Estado",
        city: "Cidade",
        region: "Região",
        country: "País"
      },
      resourceName: {
        singular: "{{name}} localização",
        plural: "localizações em {{name}}"
      }
    }
  },

  // Settings section
  settings: {
    navigation: {
      map: "Mapa",
      tags: "Etiquetas",
      customFields: "Campos personalizados",
      languages: "Idiomas",
      plan: "Plano",
      addTag: "Adicionar etiqueta",
      addField: "Adicionar campo"
    },
    planBadges: {
      trial: "!",
      endsSoon: "Termina em breve"
    },
    common: {
      loading: "A carregar...",
      error: "Erro...",
      breadcrumbs: {
        settings: "Configurações"
      },
      skeleton: {
        customFields: "Campos personalizados",
        addField: "Adicionar campo",
        name: "Nome",
        contentType: "Tipo de conteúdo",
        usedIn: "Usado em",
        field: "Campo",
        fields: "Campos"
      },
      messages: {
        savedSuccessfully: "{{setting}} configurações guardadas com sucesso",
        couldntSave: "Não foi possível guardar {{setting}} configurações"
      }
    },
    map: {
      title: "Mapa",
      messages: {
        savedSuccessfully: "Configurações do mapa guardadas com sucesso",
        couldntSave: "Não foi possível guardar configurações"
      },
      mapboxToken: {
        title: "Token do Mapbox",
        description: "Introduza o seu token do Mapbox para potenciar o seu localizador de lojas",
        label: "Token do Mapbox",
        placeholder: "Introduza o token aqui para continuar a usar o seu mapa.",
        placeholderManaged: "Introduza o token aqui para continuar a usar o seu mapa quando acabar com as suas cargas de mapa gratuitas.",
        helpText: "Siga as instruções para criar uma chave do Mapbox, depois cole a sua chave acima. Se encontrar algum problema, por favor, entre em contacto para assistência.",
        linkInstructions: "instruções para criar uma chave do Mapbox",
        linkSupport: "entre em contacto para assistência"
      },
      managedToken: {
        title: "Cargas de mapa",
        description: "Tem até {{max}} cargas de mapa gratuitas com um token gerenciado, depois disso terá de criar o seu próprio token."
      },
      appearance: {
        title: "Aparencia",
        description: "Altere a aparência do seu mapa"
      },
      mapStyle: {
        title: "Estilo do mapa",
        options: {
          streets: "Ruas",
          outdoors: "Exterior", 
          light: "Claro",
          dark: "Escuro",
          satellite: "Satélite",
          satelliteStreets: "Ruas de satélite",
          navigationDay: "Navegação Dia",
          navigationNight: "Navegação Noite"
        }
      },
      searchBehaviour: {
        title: "Comportamento de pesquisa",
        description: "Controla como os visitantes encontram localizações no seu mapa.",
        geolocateLabel: "Estime automaticamente a localização do visitante e mostre lojas próximas",
        geolocateHelp: "Se a geolocalização for bem-sucedida, o mapa mover-se-á para focar perto do visitante. Se uma localização estimada não puder ser encontrada, o mapa permanecerá na posição inicial.",
        filterBehaviour: {
          title: "Comportamento de filtragem",
          all: {
            label: "Todas as etiquetas",
            help: "Para uma localização aparecer nos filtros, deve ter todas as etiquetas selecionadas"
          },
          any: {
            label: "Qualquer etiqueta", 
            help: "Para uma localização aparecer nos filtros, pode ter qualquer uma das etiquetas selecionadas"
          }
        },
        keepSearchInView: {
          label: "Manter marcador de pesquisa na vista",
          help: "Quando os resultados da pesquisa aparecerem, o mapa irá afastar-se para mostrar todas as localizações correspondentes"
        },
        distanceUnits: {
          title: "Unidades de distância",
          km: "Quilómetros",
          miles: "Milhas"
        },
        maxResults: {
          label: "Máximo de resultados",
          help: "Limite o número de localizações mostradas nos resultados da pesquisa",
          options: {
            results30: "30 resultados"
          }
        },
        maxDistance: {
          label: "Distância máxima", 
          help: "Apenas mostre localizações dentro desta distância do ponto de pesquisa",
          options: {
            unlimited: "Ilimitado"
          }
        },
        showLocationNames: {
          label: "Mostrar nomes de localizações nas sugestões",
          help: "Exibir nomes de localizações nas sugestões de pesquisa"
        },
        sortByPriority: {
          label: "Ordenar por prioridade em vez de distância",
          help: "É altamente recomendável definir uma distância máxima (que não seja Ilimitado) se esta caixa estiver marcada. Caso contrário, os seus clientes verão localizações distantes que têm uma prioridade elevada acima das que estão dentro de uma distância razoável deles (ou a sua consulta de pesquisa, mais especificamente)."
        }
      },
      searchResults: {
        title: "Resultados da pesquisa",
        description: "Controla como as localizações são retornadas no seu mapa.",
        locationsLabel: "Texto mostrado acima dos resultados da pesquisa (e.g., 'Mostrando 5 localizações')",
        locationsHelp: "Texto mostrado antes do número de resultados", 
        prefixLabel: "Prefixo dos resultados da pesquisa", 
        prefixHelp: "Texto mostrado antes do número de resultados"
      },
      popups: {
        title: "Popups",
        showPopups: {
          label: "Mostrar popups",
          help: "Exibir detalhes da localização quando os visitantes clicarem nos marcadores do mapa"
        }
             },
       whitelabel: {
         title: "Whitelabel",
         hideLabel: "Ocultar texto de atribuição",
         hideHelp: "Remover a nossa marcação da sua localizadora de lojas"
       }
    },
    languages: {
      title: "Idiomas",
      error: "Erro...",
      messages: {
        savedSuccessfully: "Configurações de idioma guardadas com sucesso",
        couldntSave: "Não foi possível guardar configurações de idioma"
      },
      banner: {
        upgradeTitle: "Suporte a múltiplos idiomas requer upgrade de plano",
        upgradeAction: "Upgrade para Superest",
        upgradeMessage: "Ainda pode alterar o seu idioma por defeito, mas a habilitação de múltiplos idiomas requer um upgrade.",
        disabledMessage: "As configurações de múltiplos idiomas estão desabilitadas no seu plano atual"
      },
      defaultLanguage: {
        title: "Idioma por defeito", 
        description: "Escolha o seu idioma principal para o qual o seu conteúdo será exibido.",
        label: "Idioma por defeito",
        help: "Este idioma será usado quando não for solicitado um idioma específico"
      },
      internationalization: {
        title: "Internacionalização",
        description: "Habilite múltiplos idiomas. Alcance mais clientes e aumente o seu SEO.",
        enableLabel: "Habilitar múltiplos idiomas",
        enableHelp: "Permita que os clientes vejam a sua localizadora de lojas em diferentes idiomas"
      },
      supportedLanguages: {
        title: "Idiomas Suportados Adicionais",
        description: "Selecione idiomas adicionais que pretende suportar. Uma vez habilitado um idioma, verá a opção de fornecer traduções em todo o aplicativo. Para idiomas suportados, os modelos SEO por defeito, bem como os temas comuns de variáveis serão gerados automaticamente.",
        defaultLocaleNote: "Este é o seu idioma por defeito e não pode ser desabilitado",
        shopifyEnabled: {
          label: "Este idioma está habilitado na minha loja Shopify",
          importantNote: "Nota importante:",
          description: "Desmarque a caixa acima se este idioma não estiver habilitado e publicado para a sua loja Shopify. Recomenda-se habilitar o idioma para a sua loja Shopify primeiro, indo para Configurações > Idiomas na sua administração Shopify se ainda não tiver feito para uma experiência de cliente mais suave."
        },
        urlFormats: {
          cleanUrls: "URLs limpas:",
          betterSeo: "Melhor SEO e experiência do utilizador",
          queryUrls: "URLs de parâmetros de consulta:",
          considerEnabling: "Considere habilitar em Shopify para URLs melhores"
        },
        preview: {
          button: "Pré-visualizar",
          tooltip: "Pré-visualizar localizadora de lojas {{language}}"
        },
        tooltips: {
          noTemplates: "Nenhum modelo SEO por defeito disponível para este idioma. Pode criar traduções personalizadas facilmente."
        }
      }
    },
    tags: {
      title: "Etiquetas",
      addTag: "Adicionar etiqueta",
      error: "Erro",
      messages: {
        deletedSuccessfully: "Etiquetas eliminadas com sucesso",
        couldntDelete: "Não foi possível eliminar etiquetas",
        savedSuccessfully: "Etiqueta guardada com sucesso",
        couldntSave: "Por favor, verifique os seus campos",
        tagDeleted: "Etiqueta eliminada com sucesso"
      },
      resourceName: {
        singular: "etiqueta",
        plural: "etiquetas"
      },
      filters: {
        anyGroup: "Qualquer grupo",
        inGroup: "No grupo",
        tagGroup: "Grupo de etiqueta"
      },
      appliedFilters: {
        inGroup: "No grupo {{group}}",
        nameContains: "O nome da etiqueta contém {{query}}"
      },
      bulkActions: {
        deleteTag: "Eliminar etiqueta",
        deleteTags: "Eliminar etiquetas"
      },
      form: {
        language: "Idioma",
        title: "Título",
        description: "Descrição",
        group: "Grupo",
        groupPlaceholder: "Selecionar grupo",
        addGroup: "Adicionar",
        editingTranslations: "A editar as traduções de {{language}}. Os campos vazios irão exibir o conteúdo de {{defaultLanguage}}.",
        defaultValue: "Predefinido: {{value}}",
        image: "Imagem",
        imageUrl: "URL da imagem"
      },
      actions: {
        save: "Guardar",
        deleteTag: "Eliminar etiqueta"
      },
      new: {
        title: "Adicionar etiqueta",
        messages: {
          createSuccess: "Etiqueta criada com sucesso",
          checkFields: "Por favor, verifique os seus campos"
        },
        actions: {
          createTag: "Criar etiqueta"
        }
      }
    },
    customFields: {
      title: "Campos personalizados",
      addField: "Adicionar campo",
      error: "Erro",
      resourceName: {
        singular: "Campo",
        plural: "Campos"
      },
      headings: {
        name: "Nome",
        contentType: "Tipo de conteúdo",
        usedIn: "Usado em"
      },
      emptyState: {
        heading: "Criar e gerir os seus campos personalizados",
        createAction: "Criar campo",
        description: "Utilize campos personalizados para atributos únicos sobre as suas localizações. Estes campos podem ser qualquer coisa, desde perfis sociais até o nome do gestor da loja e o seu email"
      },
      pluralization: {
        location: "localização",
        locations: "localizações"
      },
      form: {
        name: "Nome",
        contentType: "Tipo de conteúdo",
        key: "Chave",
        keyPrefix: "localização.campos.",
        keyHelp: "Utilize esta chave para aceder ao conteúdo de {{name}} de uma localização em seus modelos liquid.",
        translations: {
          title: "Traduções",
          showTranslations: "Mostrar traduções",
          hideTranslations: "Ocultar traduções",
          description: "As traduções são opcionais. Os campos vazios irão exibir o nome do campo de {{language}}.",
          nameTranslation: "Nome ({{language}})",
          defaultValue: "Predefinido: {{value}}"
        }
      },
      messages: {
        savedSuccessfully: "Campo guardado com sucesso",
        couldntSave: "Não foi possível guardar o campo",
        deletedSuccessfully: "Campo eliminado com sucesso",
        couldntDelete: "Não foi possível eliminar o campo"
      },
      actions: {
        delete: "Eliminar"
      },
      new: {
        title: "Adicionar campo",
        messages: {
          savedSuccessfully: "Campo guardado com sucesso",
          couldntSave: "Não foi possível guardar o campo"
        }
      },
      contentTypes: {
        text: "Texto",
        textArea: "Área de texto", 
        email: "Email",
        number: "Número",
        phoneNumber: "Número de telefone",
        time: "Hora",
        url: "URL"
      }
    },
    plan: {
      title: "Plano",
      error: "Erro",
      changePlan: "Alterar plano",
      usdPerMonth: "USD / mês",
      sections: {
        yourPlanIncludes: "O seu plano inclui",
        nextBillingDate: "Próxima data de faturação",
        trial: "Teste"
      },
      banners: {
        planUpdated: "O seu plano foi atualizado",
        thankYouUpgrading: "Obrigado por fazer upgrade!",
        letUsKnow: "Avise-nos",
        improvementText: "se houver algo que possamos fazer melhor.",
        trialCancellation: {
          title: "Aviso de cancelamento do período de teste",
          message: "O seu período de teste gratuito de 14 dias será cancelado assim que fizer upgrade para um plano pago."
        }
      },
      locations: {
        upTo: "Até",
        locations: "localizações",
        unlimited: "Localizações ilimitadas",
        used: "usado",
        ofUsed: "{{used}} de {{max}} usado"
      },
      trial: {
        daysLeft: "{{days}} dias restantes",
        daysUsed: "{{used}} de {{total}} dias usados",
        selectPlan: "Selecionar um plano",
        currentPlan: "Plano atual",
        trialBadge: "Teste",
        currentBadge: "Atual",
        yourTrialJustStarted: "O seu teste acabou de começar",
        trialEndsAfterToday: "O seu teste termina hoje",
        trialEndsTomorrow: "O seu teste termina amanhã",
        daysLeftInTrial: "{{days}} dias restantes no seu teste",
        continueAddingLocations: "Continue a adicionar localizações depois de {{date}} selecionando um plano",
        selectPlanToday: "Por favor, selecione um plano hoje para continuar a adicionar localizações"
      },
      footer: {
        description: "Gerencie ou altere o seu plano de Localizações So Super. Consulte os nosso",
        termsOfService: "termos de serviço",
        and: "e",
        privacyPolicy: "política de privacidade"
      },
      features: {
        analytics: {
          title: "Análise",
          description: "Descubra como as pessoas estão a usar as suas localizações e onde estão a procurar"
        },
        internationalization: {
          title: "Suporte a múltiplos idiomas",
          description: "Aumente o SEO e alcance mais clientes em mercados-alvo, habilitando múltiplos idiomas"
        },
        customThemes: {
          editLiquid: {
            title: "Editar modelos liquid de temas",
            description: "Exiba os dados da localização de qualquer forma que goste com acesso aos modelos liquid"
          },
          editStructuredData: {
            title: "Editar dados estruturados de negócio",
            description: "Edite como o Google entende as páginas editando os seus dados estruturados"
          }
        }
      },
      edit: {
        title: "Alterar plano",
        allPlansInclude: "Todos os planos acima incluem",
        needingMoreLocations: "Precisa de mais localizações?",
        footerQuestion: "Tem alguma dúvida antes de começar?",
        sendMessage: "envie-nos uma mensagem",
        allFeatures: {
          seoDirectory: {
            title: "Diretório SEO e páginas de destino",
            description: "Crie automaticamente um diretório SEO de todas as suas localizações, cidades e regiões"
          },
          mapPage: {
            title: "Página de mapa com pesquisa e filtragem",
            description: "Pesquise e filtre todas as suas localizações num mapa potenciado pelo Mapbox"
          },
          tags: {
            title: "Etiquetas",
            description: "Crie etiquetas com imagens e descrições e agrupe-as"
          },
          openingHours: {
            title: "Horário de funcionamento",
            description: "Defina e exiba os horários de funcionamento das suas localizações"
          },
          mapStyles: {
            title: "Estilos de mapa",
            description: "Altere a aparência dos seus mapas com um número de estilos predefinidos"
          },
          customFields: {
            title: "Campos personalizados",
            description: "Adicione quaisquer novos campos que pretenda, desde links sociais até ao gestor da loja"
          },
          csvUpload: {
            title: "Carregar e exportar com CSV",
            description: "Carregue e edite em massa as suas localizações."
          },
          richSnippets: {
            title: "Snippet ricos",
            description: "Ajude o Google a compreender melhor as páginas com dados estruturados de negócio local"
          },
          directionsAndCalls: {
            title: "Direções e chamadas",
            description: "Os visitantes podem facilmente obter direções e fazer chamadas para as localizações"
          },
          languageSupport: {
            title: "Suporte a idiomas",
            description: "Altere o idioma por defeito para algo diferente do inglês. Os modelos de tradução fornecidos estão disponíveis para 32 idiomas principais para uma configuração fácil."
          }
        }
      },
      planCard: {
        bestToCustomize: "Melhor para personalizar",
        currentPlan: "Plano atual",
        chooseThisPlan: "Escolha este plano",
        locationsSection: "Localizações",
        featuresSection: "Funcionalidades",
        upTo: "Até",
        locations: "localizações",
        tooltipTooManyLocations: "Tem demasiadas localizações e/ou idiomas habilitados para este plano."
      },
      confirmation: {
        error: "Erro ao confirmar plano"
      }
    }
  },

  // Themes section
  themes: {
    title: "Temas",
    currentTheme: {
      title: "Tema atual",
      description: "Este é o tema que os clientes veem quando visitam a sua aplicação de localizações."
    },
    themeLibrary: {
      title: "Biblioteca de temas", 
      description: "Gerencie os seus temas de localizações. Adicione e publique temas para alterar a aparência da sua localização online."
    },
    skeleton: {
      currentThemeDescription: "Este é o tema que os clientes veem quando usam a sua aplicação de localizações."
    },
    modal: {
      overrideTitle: "Substituir tema atual?",
      override: "Substituir",
      cancel: "Cancelar",
      undoWarning: "Esta ação não pode ser desfeita."
    },
    messages: {
      publishSuccess: "Tema publicado com sucesso",
      publishError: "Não foi possível publicar o tema",
      error: "Ocorreu um erro"
    },
    emptyStates: {
      settings: {
        heading: "Este tema não tem configurações",
        description: "Crie configurações no editor de modelos.",
        createSettings: "Criar configurações",
        upgradePlan: "Upgrade de plano",
        upgradeRequired: "Upgrade de plano para criar configurações"
      },
      language: {
        heading: "Este tema não tem termos de idioma",
        description: "Crie termos de idioma no editor de modelos.",
        createLanguageTerms: "Criar termos de idioma",
        upgradePlan: "Upgrade de plano",
        upgradeRequired: "Upgrade de plano para criar termos de idioma"
      }
    },
    templates: {
      categories: {
        templates: "Modelos",
        schemas: "Esquemas",
        styles: "Estilos",
        liquidReference: "Referência liquid"
      },
      items: {
        landing: "Destino",
        directory: "Diretório",
        country: "País",
        region: "Região",
        city: "Cidade",
        location: "Localização",
        language: "Idioma",
        settings: "Configurações",
        stylesheet: "Ficheiro CSS"
      },
      errors: {
        errorsInTemplate: "Erros no modelo",
        error: "Erro"
      },
      badges: {
        errors: "Erros!",
        unsaved: "Não guardado"
      },
      actions: {
        viewTheme: "Visualizar tema",
        discard: "Descartar",
        save: "Guardar"
      }
    },
    language: {
      messages: {
        saveSuccess: "Traduções de tema guardadas com sucesso",
        saveError: "Não foi possível guardar o tema"
      },
      form: {
        language: "Idioma",
        defaultLanguageHelp: "Este é o seu idioma por defeito",
        translationHelp: "A editar as traduções de {{selectedLocale}}. Os campos vazios irão exibir o conteúdo de {{defaultLocale}} (o seu idioma por defeito)."
      },
      banner: {
        multipleLanguagesNotEnabled: {
          title: "Múltiplos idiomas não habilitados",
          action: "Habilitar em Configurações",
          description: "Para gerir traduções para múltiplos idiomas, habilite a internacionalização nas suas configurações de idioma. Atualmente, apenas são mostradas traduções de {{locale}}."
        },
        translating: {
          title: "A traduzir de {{from}} para {{to}}",
          description: "Qualquer campo que deixe vazio irá automaticamente exibir o conteúdo de {{defaultLocale}} para os seus clientes. Apenas traduza os campos onde pretende conteúdo diferente em {{selectedLocale}}."
        }
      },
      accessLanguageTerms: "Aceda aos termos de {{category}} em liquid com {{code}}",
      fields: {
        // Common language fields - add specific ones as needed
        title: "Título",
        description: "Descrição",
        heading: "Título",
        subheading: "Subtítulo",
        button_text: "Texto do botão",
        link_text: "Texto do link",
        placeholder: "Placeholder",
        label: "Etiqueta",
        help_text: "Texto de ajuda",
        error_message: "Mensagem de erro",
        success_message: "Mensagem de sucesso",
        
        // Opening hours
        Monday: "Segunda-feira",
        Tuesday: "Terça-feira",
        Wednesday: "Quarta-feira",
        Thursday: "Quinta-feira",
        Friday: "Sexta-feira",
        Saturday: "Sábado",
        Sunday: "Domingo",
        opening_hours_format: "Formato de horário de funcionamento",
        closes_at_format: "Formato de fecho às",
        opens_at_format: "Formato de abertura às",
        opens_on: "Abre em",
        open_24h: "Aberto 24h",
        open: "Aberto",
        closed: "Fechado",
        closes_at: "Fechar às",
        opens_at: "Abrir às",
        
        // Map
        search_map: "Pesquisar mapa",
        search_area: "Pesquisar esta área",
        view_map: "Mapa",
        view_list: "Lista",
        open_filters: "Filtros",
        stores_near_you: "Lojas próximas",
        header: "Encontre uma Loja!",
        search_placeholder: "Digite um código postal ou endereço...",
        no_listings: "Desculpe, não encontramos nenhuma localização para a sua pesquisa. Tente alterar os filtros ou a localização de pesquisa",
        
        // Directory
        view_directory: "Diretório da Loja",
        
        // Location
        get_directions: "Direções",
        call: "Chamar",
        view_website: "Website",
        email: "Email",
        opening_hours_header: "Horário de funcionamento",
        description_header: "Informação",
        phone_number_header: "Telefone",
        address_header: "Endereço",
        tag_groups_to_display: "Grupos de etiquetas a exibir"
      },
      categories: {
        // Common language categories - add specific ones as needed
        general: "Geral",
        navigation: "Navegação",
        forms: "Formulários",
        buttons: "Botões",
        messages: "Mensagens",
        errors: "Erros",
        opening_hours: "Horário de funcionamento",
        map: "Mapa",
        directory: "Diretório",
        location: "Localização"
      }
    },
    settings: {
      messages: {
        saveSuccess: "Tema guardado com sucesso",
        saveError: "Não foi possível guardar o tema"
      },
      accessSettings: "Aceda às configurações de {{category}} em liquid com {{code}}",
      fields: {
        // Colors
        color_text: "Cor do texto",
        color_text_heading: "Cor do texto do título", 
        color_background: "Cor de fundo",
        color_accent: "Cor de acento",
        color_text_positive: "Cor do texto positiva",
        color_text_negative: "Cor do texto negativa",
        dark_theme: "Tema escuro",
        color_marker: "Cor do marcador",
        color_search_marker: "Cor do marcador de pesquisa",
        
        // Typography
        base_font_size: "Tamanho da fonte base",
        
        // Buttons
        border_radius: "Raio do bordo",
        
        // Images
        aspect_ratio: "Razão de aspecto",
        fit: "Ajustar",
        
        // Spacing
        page_width: "Largura da página",
        page_width_small: "Largura da página pequena",
        gutter_desktop: "Gutter desktop",
        gutter_mobile: "Gutter mobile",
        desktop_vertical_spacing: "Espaçamento vertical desktop",
        mobile_vertical_spacing: "Espaçamento vertical móvel",
        
        // Breakpoints
        breakpoint_xs: "Breakpoint XS",
        breakpoint_sm: "Breakpoint SM",
        breakpoint_md: "Breakpoint MD",
        
        // Map
        search_on_move: "Pesquisar ao mover",
        scroll_to_zoom: "Rolagem para zoom",
        
        // Landing page
        sidebar_width: "Largura do sidebar",
        sidebar_min_height: "Altura mínima do sidebar",
        marker_image_src: "Fonte da imagem do marcador",
        show_filter_descriptions: "Mostrar descrições de filtro",
        
        // Location page
        tag_groups_to_display: "Grupos de etiquetas a exibir",
        tag_groups_to_display_as_icons: "Grupos de etiquetas a exibir como ícones",
        show_related_locations: "Mostrar localizações relacionadas",
        
        // Locations
        hide_regions: "Ocultar regiões"
      },
      categories: {
        colors: "Cores",
        typography: "Tipografia",
        buttons: "Botões",
        images: "Imagens",
        spacing: "Espaçamento",
        breakpoints: "Breakpoints",
        map: "Mapa",
        landing_page: "Página de destino",
        location_page: "Página de localização",
        locations: "Localizações"
      }
    },
    navigation: {
      sublimeTheme: "Tema Sublime",
      settings: "Configurações",
      language: "Idioma",
      templates: "Modelos",
      changeTheme: "Alterar tema",
      viewDirectory: "Visualizar diretório",
      viewLandingPage: "Visualizar página de destino"
    },
    card: {
      lastUpdated: "Última atualização",
      view: "Visualizar",
      customize: "Personalizar",
      publish: "Publicar",
      actions: "Ações"
    }
  },

  // Analytics section
  analytics: {
    title: "Análise",
    timePeriods: {
      last7days: "Últimos 7 dias",
      last30days: "Últimos 30 dias"
    },
    comparison: {
      compareToPrevious: "Comparar com o período anterior",
      stopComparing: "Parar de comparar com o período anterior"
    },
    sections: {
      searchLocations: "Pesquisar localizações"
    },
    cards: {
      sessions: "Sessões",
      topSearches: "Pesquisas mais frequentes",
      topLandingPageType: "Tipo de página de destino mais frequente",
      topPageViewsBySession: "Visualizações de página por sessão",
      topLocations: "Localizações mais frequentes",
      topReferrers: "Referências mais frequentes",
      searches: "Pesquisas",
      topLandingPagesBySession: "Páginas de destino por sessão"
    },
    chartLabels: {
      desktop: "Desktop"
    }
  },

}; 